var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCasaRodante(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #343434;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M442.1,149.3h27.2c23.6,0,42.7-19.1,42.7-42.7,0-47.1-38.2-85.3-85.3-85.3H106.7C47.8,21.4,0,69.1,0,128v139c-.1,39.6,15.6,77.6,43.7,105.6l20.3,20.3v23.2c0,41.2,33.4,74.7,74.7,74.7s74.7-33.4,74.7-74.7v-10.7h106.7v10.7c0,41.2,33.4,74.7,74.7,74.7s74.7-33.4,74.7-74.7v-10.7h21.3c11.8,0,21.3-9.6,21.3-21.3v-72.7c0-26-6.8-51.5-19.7-74.1l-50.2-87.9ZM42.7,149.3h128v42.7H42.7v-42.7ZM170.7,416c0,17.7-14.3,32-32,32s-32-14.3-32-32v-10.7h64v10.7ZM277.3,362.7H94.2l-20.3-20.3c-20.1-20-31.3-47.1-31.2-75.4v-32.3h128c23.6,0,42.7-19.1,42.7-42.7v-42.7c0-23.6-19.1-42.7-42.7-42.7H46.3c9-25.6,33.2-42.7,60.3-42.7h320c23.6,0,42.7,19.1,42.7,42.7h-106.7c-47.1,0-85.3,38.2-85.3,85.3v170.7ZM441.6,234.7h-121.6v-42.7c0-23.6,19.1-42.7,42.7-42.7h30.3l48.7,85.3ZM426.7,416c0,17.7-14.3,32-32,32s-32-14.3-32-32v-10.7h64v10.7ZM469.3,362.7h-149.3v-85.3h143.8c3.7,11,5.6,22.4,5.6,34v51.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasaRodante);
export default __webpack_public_path__ + "static/media/casa-rodante.1e0f92cf1502f853ce85525328bbb506.svg";
export { ForwardRef as ReactComponent };